// @ts-nocheck
import { FC, useEffect, useState } from "react";
import {
  inputGeneral,
  IInputGeneral,
  TypeIdGeneral,
  GENDER_NUMBERS,
} from "./constants";
import styles from "./ModelInfo.module.scss";
import { Button } from "../ui";
import MultiDropdown from "../ui/Dropdown/MultiDropdown";
import { Input } from "../ui/Input/Input";
import { InputPassword } from "../ui/InputPassword/InputPassword";
import { DropdownTwo } from "../ui/Dropdown/DropdownTwo";
import { IResponseGetClubs } from "../../types/club";
import { getClubs } from "../../api/clubs";
import { useAppDispatch, useAppSelector } from "../../services/hooks";
import { getLanguages } from "../../api/language";
import { ILangModel } from "../../types/lang";
import Loader from "../Loader/Loader";
import { IRequestPatchUser } from "../../types/user";
import { updateUser } from "../../services/slices/user";

export const BlockGeneral: FC = () => {
  const [formData, setFormData] = useState<IInputGeneral[]>(inputGeneral);
  const [isLoading, setIsLoading] = useState(false);
  const { user } = useAppSelector((state) => state.user);
  const dispatch = useAppDispatch();
  const setUserData = useCallback(() => {
    if (user) {
      setFormData((prevData) =>
        prevData.map((item) => {
          switch (item.id) {
            case "firstname":
              return { ...item, value: user.firstName || "" };
            case "lastname":
              return { ...item, value: user.lastName || "" };
            case "gender":
              return {
                ...item,
                value: user.gender ? Number(GENDER_NUMBERS[user.gender]) : 0,
              };
            case "lang":
              return {
                ...item,
                value: user.language.map((val) => val.id) || [],
              };
            case "email":
              return { ...item, value: user.email || "" };
            case "password":
              return { ...item, value: "" }; // Assuming password is not set from user data
            case "date":
              return {
                ...item,
                value: user.model?.birthDate
                  ? new Date(user.model.birthDate).toISOString().split("T")[0]
                  : "",
              };
            case "tel":
              return { ...item, value: user.model?.phone || "" };
            case "city":
              return { ...item, value: user.model?.city || "" };
            case "code":
              return {
                ...item,
                value: user.model?.zipIndex
                  ? Number(user.model.zipIndex)
                  : null,
              };
            case "club":
              return {
                ...item,
                value: user.usersClubs.map((club) => club.clubId) || [],
              };
            default:
              return item;
          }
        }),
      );
    }
  }, [user]);

  async function patchUser() {
    const gender = formData.find((val) => val.id === "gender")?.value;
    const clubs = formData.find((val) => val.id === "club")?.value;
    const languages = formData.find((val) => val.id === "lang")?.value;
    const newData: IRequestPatchUser = {
      firstName:
        formData.find((val) => val.id === "firstname")?.value || undefined,
      lastName:
        formData.find((val) => val.id === "lastname")?.value || undefined,
      gender: gender ? (gender === 1 ? "M" : "F") : undefined,
      language: languages
        ? languages.map((lang) => ({ languageId: lang }))
        : undefined,
      email: formData.find((val) => val.id === "email")?.value || undefined,
      model: {
        birthDate:
          formData.find((val) => val.id === "date")?.value || undefined,
        phone: formData.find((val) => val.id === "tel")?.value || undefined,
        city: formData.find((val) => val.id === "city")?.value || undefined,
        zipIndex: formData.find((val) => val.id === "code")?.value || undefined,
      },
      usersClubs: clubs ? clubs.map((club) => ({ clubId: club })) : undefined,
    };

    dispatch(updateUser(newData));
  }

  async function fetchData() {
    setIsLoading(true);
    const clubs: IResponseGetClubs = await getClubs();
    const languages: ILangModel[] = await getLanguages();

    setFormData((prevData) =>
      prevData.map((item) =>
        item.id === "club"
          ? {
              ...item,
              options: clubs.data.map((club) => ({
                id: club.id,
                name: club.club,
              })),
            }
          : item.id === "lang"
            ? {
                ...item,
                options: languages.map((lang) => ({
                  id: lang.id,
                  name: lang.language,
                })),
              }
            : item,
      ),
    );

    setIsLoading(false);
  }

  useEffect(() => {
    fetchData();
    setUserData();
  }, [setUserData, user]);

  const handleChange = (
    newValue: string | number | number[],
    id: TypeIdGeneral,
  ) => {
    setFormData((prevData: IInputGeneral[]) =>
      prevData.map((item) =>
        item.id === id ? { ...item, value: newValue } : item,
      ),
    );
  };

  return (
    <div>
      {isLoading ? (
        <div className={styles.loader}>
          <Loader color="#ac2386" size={60} borderWidth={5} />
        </div>
      ) : (
        <>
          <form className={styles.BlockGeneral}>
            {formData.map((item) => {
              if (item.type === "selectMulti" && item.options) {
                return (
                  <MultiDropdown
                    key={item.id}
                    options={item.options}
                    label={item.label}
                    onChange={(newValue) => handleChange(newValue, item.id)}
                    placeholder={item.placeholder}
                    selectedOptions={item.value}
                  />
                );
              } else if (item.type === "select" && item.options) {
                return (
                  <DropdownTwo
                    key={item.id}
                    name={item.label}
                    setState={(newValue) => handleChange(newValue, item.id)}
                    data={item.options}
                    state={
                      item.options.find((op) => op.id === item.value)?.name ||
                      null
                    }
                    placeholder={item.placeholder}
                  />
                );
              } else if (item.type === "password") {
                <InputPassword
                  id={String(item.id)}
                  label={item.label}
                  type={item.type}
                  value={item.value}
                  className={styles.inputField}
                  onChange={(e) => handleChange(e.target.value, item.id)}
                  placeholder="Enter password"
                />;
              } else if (item.type !== "select" && item.type !== "password") {
                return (
                  <Input
                    id={String(item.id)}
                    label={item.label}
                    type={item.type}
                    value={item.value}
                    className={styles.inputField}
                    onChange={(e) => handleChange(e.target.value, item.id)}
                    placeholder={item.placeholder}
                  />
                );
              }
            })}
          </form>
          <div className={styles.ButtonBlock}>
            <div className={styles.Button}>
              <Button onClick={patchUser}>Edite</Button>
            </div>
          </div>{" "}
        </>
      )}
    </div>
  );
};
